import { render, staticRenderFns } from "./TasinirHacziForm.vue?vue&type=template&id=36c0031e"
import script from "./TasinirHacziForm.vue?vue&type=script&lang=ts"
export * from "./TasinirHacziForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports